import { createSelector } from 'reselect';
import TrackedItemsInPredesDetailsColumns
  from '../../containers/TrackedItemsInPredesDetailsColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.TRACKED_ITEMS_IN_PREDES_DETAILS
    .metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.TRACKED_ITEMS_IN_PREDES_DETAILS.isLoading;

export const getData =
  ReportDefinitions.TRACKED_ITEMS_IN_PREDES_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, TrackedItemsInPredesDetailsColumns);
